export default __webpack_public_path__ + "static/media/ivana-cajina-TUXUCVXmjQk-unsplash.d28b2940.jpg";